<template>
  <div>

  </div>
</template>

<script>

import AWiki from '@/components/AWiki.vue'
import InfoFields from '@/components/learn/InfoFields.vue'
import SoiGraph from '@/components/SoiGraph.vue'

export default {
  components: {
    AWiki,
    InfoFields,
    SoiGraph
  },
  data () {
    return {
      'header': 'Digitala verktyg'
    }
  },
  created () {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/learn/tracks/source/chapters/tools.vue